import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountries, selectAuth } from "store/slices/auth.slice";
import { getCountryWithTimezone } from "assets/json/timezones";

const useCountries = () => {
  // const [detectedCountry, setDetectedCountry] = useState("");
  const dispatch = useDispatch();
  const {
    countries: { data, status },
  } = useSelector(selectAuth);

  /*eslint-disable */
  const getCountries = useCallback(() => {
    dispatch(fetchCountries());
  }, [dispatch, fetchCountries]);

  const detectCountry = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const ctry = getCountryWithTimezone(tz);
    return ctry;
  };

  useEffect(() => getCountries(), [getCountries]);

  return {
    data,
    status,
    refetch: getCountries,
    detectedCountry: detectCountry(),
  };
};

export default useCountries;
